module.exports = __webpack_public_path__ + "static/media/img-exhibition-reference02.5ffe8462.jpg";